import React from 'react'

export default function Density() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.33398 12.5001H16.6673V10.8334H3.33398V12.5001ZM3.33398 15.8334H16.6673V14.1667H3.33398V15.8334ZM3.33398 9.16675H16.6673V7.50008H3.33398V9.16675ZM3.33398 4.16675V5.83341H16.6673V4.16675H3.33398Z" fill="#03555E" />
    </svg>
  )
}
